import React from 'react';
import styled, { css } from 'styled-components';
import { useLanguage } from '../context/LanguageContext';
import { useInView } from '../hooks/useInView';
import { UsaMap } from './UsaMap';

const Section = styled.section`
  padding: 140px 0;
  background: #FFFDF7;
  @media (min-width: 768px) { padding: 180px 0; }
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 32px;
  transition: opacity 1s ease, transform 1s ease;
  ${({ $inView }) =>
    $inView
      ? css`opacity: 1; transform: translateY(0);`
      : css`opacity: 0; transform: translateY(40px);`}
`;

const Layout = styled.div`
  display: grid;
  gap: 60px;
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 2fr;
    gap: 80px;
    align-items: center;
  }
`;

const TextSide = styled.div``;

const Eyebrow = styled.p`
  font-family: 'Raleway', serif;
  font-size: 0.72rem;
  letter-spacing: 0.22em;
  color: #C07020;
  margin-bottom: 20px;
`;

const Title = styled.h2`
  font-family: 'Cormorant Garamond', serif;
  font-size: clamp(2.8rem, 5vw, 4rem);
  font-weight: 300;
  font-style: italic;
  color: #1A1208;
  letter-spacing: -0.01em;
  line-height: 1.05;
  margin-bottom: 28px;
`;

const Rule = styled.div`
  width: 48px;
  height: 1px;
  background: #C07020;
  margin-bottom: 28px;
`;

const Body = styled.p`
  font-size: 0.92rem;
  font-weight: 300;
  color: rgba(26,18,8,0.72);
  line-height: 1.85;
  max-width: 380px;
`;

const MapSide = styled.div``;

const StateList = styled.div`
  display: flex;
  flex-direction: column;
`;

const StateRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 0;
  border-top: 1px solid rgba(26,18,8,0.1);
  transition: opacity 0.8s ease, transform 0.8s ease;
  transition-delay: ${({ $delay }) => $delay}ms;
  ${({ $inView }) =>
    $inView
      ? css`opacity: 1; transform: translateX(0);`
      : css`opacity: 0; transform: translateX(20px);`}
  &:last-child { border-bottom: 1px solid rgba(26,18,8,0.1); }
`;

const StateName = styled.span`
  font-family: 'Cormorant Garamond', serif;
  font-size: clamp(1.5rem, 3.5vw, 2rem);
  font-weight: 400;
  color: #1A1208;
  letter-spacing: -0.01em;
`;

const StateTag = styled.span`
  font-size: 0.7rem;
  font-weight: 400;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(26,18,8,0.52);
`;

const points = [
  { name: 'California', tag: 'USA' },
  { name: 'Oklahoma',   tag: 'USA' },
  { name: 'Kansas',     tag: 'USA' },
  { name: 'Texas',      tag: 'USA' },
];

export function PointsOfSale() {
  const { t } = useLanguage();
  const { ref, isInView } = useInView({ threshold: 0.2 });

  return (
    <Section id="points-of-sale">
      <Container ref={ref} $inView={isInView}>
        <Layout>
          <TextSide>
            <Eyebrow>{t('Presence', 'Presencia')}</Eyebrow>
            <Title>{t('Available across the United States.', 'Disponibles en Estados Unidos.')}</Title>
            <Rule />
            <Body>
              {t(
                'Our cajeta is sold at select stores and independent retailers in four U.S. states. Ask for Hacienda Real at your local Mexican grocery.',
                'Nuestra cajeta se vende en tiendas seleccionadas y distribuidores independientes en cuatro estados de EE. UU. Pregunta por Hacienda Real en tu tienda mexicana local.'
              )}
            </Body>
          </TextSide>
          <MapSide>
            <UsaMap />
          </MapSide>
        </Layout>
      </Container>
    </Section>
  );
}
